/* ••[1]••••••••••••••••••••••••• TestimonialQuoteController.ts •••••••••••••••••••••••••••••• */

/* ••[2]•••••••••• Components ••••••••••••••• */
import CCCTestimonialQuote from "../components/testimonial-quote/testimonialQuote";

/* ••[2]•••••••••• Models ••••••••••••••• */
import TestimonialQuoteModel from "./../models/TestimonialQuoteModel";

/* ••[2]•••••••••• Types ••••••••••••••• */
import { TestimonialQuote } from "../core/types/TestimonialQuote";
// import EventModel from "../models/EventModel";
import { VanillaPagesType } from "../core/types/VanillaPages";
import { CCCPanel } from "../components/panel/panel";
export default class TestimonialQuoteController {
  private $anchor: HTMLElement | null = null;
  private CCCTestimonialQuoteInstance: CCCTestimonialQuote | null;

  constructor(anchor: string) {
    try {
      this.$anchor = document.querySelector(anchor);

      if (!this.$anchor) {
        throw `Testimonial Quote - ${anchor} element not found in DOM`;
      }
    } catch (error) {
      console.error(error);
    }
  }

  /* ••[2]•••••••••• Implementation ••••••••••••••• */
  public get instance(): CCCTestimonialQuote | null {
    return this.CCCTestimonialQuoteInstance;
  }

  public async init(
    type: VanillaPagesType
  ): Promise<CCCTestimonialQuote | null> {
    switch (type) {
      case VanillaPagesType.categories:
      case VanillaPagesType.discussions:
        return await this._createPanel();
        break;
      default:
        return null;
        break;
    }

    return null;
  }

  private async _createPanel(): Promise<CCCTestimonialQuote> {
    this.CCCTestimonialQuoteInstance = new CCCTestimonialQuote();
    const cccPanel: CCCPanel = document.createElement("ccc-panel") as CCCPanel;
    cccPanel.setAttribute("title", "");
    cccPanel.setAttribute("padding-horizontal", "0");
    this.CCCTestimonialQuoteInstance.setAttribute("slot", "component");
    cccPanel.append(this.CCCTestimonialQuoteInstance);
    this.$anchor.appendChild(cccPanel);
    await this.setData();

    return this.CCCTestimonialQuoteInstance;
  }

  private async setData(): Promise<void> {
    if (this.CCCTestimonialQuoteInstance) {
      try {
        const testimonialQuotes: Array<TestimonialQuote> =
          await TestimonialQuoteModel.getTestimonialQuoteData();

        this.CCCTestimonialQuoteInstance.testimonialQuote =
          testimonialQuotes[
            Math.floor(Math.random() * (testimonialQuotes.length + 1))
          ];
      } catch (error) {
        return null;
      }
    }
  }
}
